export default __webpack_public_path__ + "static/media/ice.cd2f9043.svg";